import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useDispatch } from "react-redux";
import { logoutUser } from "./logoutHelper";

export function TokenSyncListener() {
    const auth = useAuth();
    let dispatch = useDispatch();

    useEffect(() => {
  const handleStorage = (event) => {
    if (event.key === "logout") {
      logoutUser({ auth, dispatch });
    }
  };

  window.addEventListener("storage", handleStorage);
  return () => {
    window.removeEventListener("storage", handleStorage);
  };
}, [auth]);


    return null;
}
